import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReferalState {
  infoModal: boolean;
}

const initialState: ReferalState = {
  infoModal: false,
};

const referalSlice = createSlice({
  name: "info",
  initialState,
  reducers: {
    setInfoModal(state, action: PayloadAction<boolean>) {
      state.infoModal = action.payload;
    },
  },
});

export const { setInfoModal } = referalSlice.actions;
export default referalSlice.reducer;
